<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div style="margin-bottom: 10px">
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="巡更点名称" prop="title" label-width="100px">
                <el-input
                  v-model="searchForm.title"
                  size="medium"
                  placeholder="请输入巡更点名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="设备编号"
                prop="deviceNumber"
                label-width="100px"
              >
                <el-input
                  v-model="searchForm.deviceNumber"
                  size="medium"
                  placeholder="请输入设备编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="一级分类"
                prop="patrolLevelParentId"
                label-width="100px"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.patrolLevelParentId"
                  @change="changeType($event,1)"
                  placeholder="请选择一级分类"
                >
                  <el-option
                    v-for="item in TypeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="二级分类"
                prop="patrolLevelId"
                label-width="100px"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.patrolLevelId"
                  placeholder="请选择二级分类"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="设备位置"
                prop="deviceAddress"
                label-width="100px"
              >
                <el-input
                  v-model="searchForm.deviceAddress"
                  size="medium"
                  placeholder="请输入设备位置"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="时间范围" prop="time" label-width="100px">
                <el-date-picker
                  style="width: 100%;"
                  v-model="timeList"
                  size="medium"
                  type="daterange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px;margin-left: 30px;"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 0 20px 20px 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          plain
          type="primary"
          @click="downloadimg"
          style="width: 90px"
          >批量下载</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="downloadurl"
          style="width: 90px"
          >导出</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        ref="table"
        @select="handleSelect"
        type="selection"
        @select-all="handleSelectAll"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column prop="title" label="巡更点名称" align="center">
        </el-table-column>
        <el-table-column prop="patrolLevel" label="巡更点类型" align="center">
        </el-table-column>
        <el-table-column prop="deviceNumber" label="设备编号" align="center">
        </el-table-column>
        <el-table-column prop="deviceAddress" label="设备位置" align="center">
        </el-table-column>
        <el-table-column prop="qrecord" label="二维码" align="center">
          <template slot-scope="scope">
            <a @click="bindQrecord(scope.row.id)" v-if="!scope.row.qrCode"
              >生成二维码</a
            >
            <img
              v-else
              :src="scope.row.qrCode"
              alt=""
              @click="addRecord(scope.row.qrCode)"
              width="70px"
              height="70px"
              style="cursor: pointer"
            />
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
      </el-table-column>     
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              v-if="scope.row.qrCode"
              @click="bindQrecord(scope.row.id)"
              >重新生成二维码</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog
        :title="modalTitle"
        :close-on-click-modal="false"
        :visible.sync="isAddModal"
        width="50%"
      >
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="巡更点名称" prop="title" label-width="120px">
                <el-input
                  v-model="addData.title"
                  maxlength="30"
                  placeholder="请输入巡更点名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="巡更点分类"
                prop="patrolLevelParentId"
                label-width="120px"
              >
                <el-select
                  clearable filterable
                  v-model="addData.patrolLevelParentId"
                  @change="changeType($event,1)"
                  placeholder="请选择一级分类"
                >
                  <el-option
                    v-for="item in TypeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="" prop="patrolLevelId" label-width="120px">
                <el-select
                  clearable filterable
                  v-model="addData.patrolLevelId"
                  placeholder="请选择二级分类"
     
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                    :disabled="item.disabled"
                    @click.native="onchangeStatus(item)"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="设备编号"
                prop="deviceNumber"
                label-width="120px"
              >
                <el-input
                  v-model="addData.deviceNumber"
                  maxlength="30"
                  placeholder="请输入设备编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="设备位置"
                prop="deviceAddress"
                label-width="120px"
              >
                <el-input
                  v-model="addData.deviceAddress"
                  maxlength="30"
                  placeholder="请输入设备位置"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogVisible"
        style="z-index: 1999"
        width="30%"
      >
        <a :href="dialogImageUrl" target="downloadFile"
          ><img width="100%" :src="dialogImageUrl" alt=""
        /></a>
        <div style="width: 100%; text-align: center">点击下载二维码</div>
      </el-dialog>
    </div>
  </div>
</template> 
  
  <script>
import JSZip from "jszip";
import UnpackAndDownImage from "@/utils/zipDownLoad";
export default {
  data() {
    return {
      searchForm: {
        title:"",
        deviceAddress:"",
        deviceNumber:"",
        patrolLevelId:"",
        patrolLevelParentId:"",
        startTime:"",
        endTime:""
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      dialogVisible: false,
      dialogImageUrl: "",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        title: "",
        patrolLevelId:""
      },
      addDataRules: {
        title: [
          { required: true, message: "请输入巡更点名称", trigger: "blur" },
        ],
        patrolLevelParentId: [
          { required: true, message: "请选择一级分类", trigger: "blur" },
        ],
        patrolLevelId: [
          { required: true, message: "请选择二级分类", trigger: "blur" },
        ],
        deviceAddress:[{ required: true, message: "请输入设备位置", trigger: "blur" },]
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      imgs: [],
      managers: [],
      TypeList: [],
      statusList: [],
      timeList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.onLoad();
    this.patrolLevelTotalList();
  },
  watch: {
    //监听表格数据变化时回显，判断有数据时及弹窗绑定值为true时调用回显,不然会报同上问题
    tableData(newVal) {
      if (newVal.length > 0) {
        this.showSelection();
      }
    },
  },
  methods: {
    downloadurl() {
      let url =
        process.env.VUE_APP_UPLOAD_REAL_PATH +
        "/export/patrolPoint?villageId=" +
        JSON.parse(localStorage.getItem("park_data")).id + 
        "&title=" + this.searchForm.title + 
        "&deviceNumber=" + this.searchForm.deviceNumber + 
        "&deviceAddress=" + this.searchForm.deviceAddress + 
        "&patrolLevelId=" + this.searchForm.patrolLevelId + 
        "&patrolLevelParentId=" + this.searchForm.patrolLevelParentId + 
        "&startTime=" + this.searchForm.startTime + 
        "&endTime=" + this.searchForm.endTime;
        window.location.href = url
    },
    onchangeStatus(e){
      if(e.disabled){
        this.$message.warning('暂无检查内容，请填写检查内容后选择!')
      }
    },
    // 获取二级分类
    changeType(e,ind) {
      this.$Apis.patrolLevelsonList({ parentId: e }).then((res) => {
        if (res.code == 200) {
          if(ind == 1){
            this.addData.patrolLevelId = ""
          }
          res.data.forEach(item=>{
            if(!item.content){
              item.disabled = true
            }else{
              item.disabled = false
            }
          })
          this.statusList = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 获取巡更标准总列表
    patrolLevelTotalList() {
      this.$Apis.patrolLevelTotalList({ rank: 1 }).then((res) => {
        if (res.code == 200) {
          this.TypeList = res.data;
        }
      });
    },
    //多选
    handleSelect(selection, row) {
      //声名标记，判断已选择项数组是否存在当前选中项，若存在删除该项，不存在则添加
      let flag;
      //深拷贝已选择项，我这里是兄弟组件传值，改变原数组的话会导致还没点击确定，兄弟组件就接到了新值
      let newArr = JSON.parse(JSON.stringify(this.managers));
      newArr.forEach((item, index) => {
        if (item.id == row.id) {
          newArr.splice(index, 1);
          flag = true;
        }
      });
      if (!flag) {
        newArr.push({ id: row.id, img: row.qrCode });
      }
      this.managers = newArr;
    },
    //全选
    handleSelectAll(selection) {
      //参数selection为当前页的选中项数组,长度大于0则为全部选中，相反为全部取消选中
      if (selection.length > 0) {
        //stateArr为暂存已选择项,深拷贝selection数组，这里是将selection元素全部添加到stateArr
        this.stateArr = JSON.parse(JSON.stringify(selection));
        //深拷贝已选中项数组，因业务需求我这里是兄弟组件传入的已选中项，
        //由于是点击确定按钮时传值不另外声名的话会导致改变managers时
        //兄弟组件监听到变化直接改变了managers数组
        let newManagers = JSON.parse(JSON.stringify(this.managers));
        selection.forEach((item) => {
          newManagers.push({ id: item.id, img: item.qrCode });
        });
        //数组中对象根据id去重
        var objItem = {},
          newAry = [];
        for (var i = 0; i < newManagers.length; i++) {
          if (!objItem[newManagers[i].id]) {
            newAry.push(newManagers[i]);
            objItem[newManagers[i].id] = true;
          }
        }
        this.managers = newAry;
      } else {
        //取消全部选中的状态，此时stateArr为当前业的表格数据，用于判断取消选中的哪页数据
        this.stateArr = JSON.parse(JSON.stringify(this.tableData));
        //map方法将每项的id放 入set数组中
        var set = this.stateArr.map((item) => {
          return item.id;
        });
        //根据id过滤掉已选择项数组中存在这些id的数据
        var resArr = this.managers.filter((item) => !set.includes(item.id));
        this.managers = resArr;
      }
    },
    //表格多选回显
    showSelection() {
      let arr = [];
      let set = this.managers.map((item) => {
        return item.id;
      });
      //过滤出已选择项和table数据中id对应上的数据，完成回显
      arr = this.tableData.filter((item) => {
        return set.includes(item.id);
      });
      this.$nextTick(() => {
        arr.forEach((item) => {
          this.$refs.table.toggleRowSelection(item);
        });
      });
    },
    // 批量下载图片
    downloadimg() {
      if (this.managers.length > 0) {
        this.imgs = this.managers.map((res) => res.img);
        let arr = [];
        this.imgs.forEach((item) => {
          this.$Apis.verificationBase64({ imgUrl: item }).then((res) => {
            arr.push("data:image/jpg;base64," + res.data);
            if (arr.length == this.imgs.length) {
              new UnpackAndDownImage({
                imgSrcList: this.imgs,
                imgBase64: arr,
                folderName: "二维码文件",
                onError(err) {
                  // console.log(err)
                },
                onProgress(res) {
                  // console.log('onProgress',res)
                },
                onSuccess(res) {
                  // console.log('onSuccess',res)
                },
              });
            }
          });
        });
      } else {
        this.$message.warning("请选择");
      }
    },

    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.timeList = "";
      this.onLoad();
    },
    // 生成二维码
    bindQrecord(id) {
      this.$Apis.patrolGenerateQrCode({ id }).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.onLoad();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    async updataCharacter(row) {
      await this.changeType(row.patrolLevelParentId,2);
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.patrolClassDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let {
            title,
            deviceAddress,
            deviceNumber,
            patrolLevelId,
            patrolLevelParentId,
          } = this.addData;
          var data = {
            id: this.addData.id || "",
            title,
            type: 1,
            deviceAddress,
            deviceNumber,
            patrolLevelId,
            patrolLevelParentId,
          };
          this.$Apis.patrolClassAddUp(data).then((res) => {
            this.btnLoading = false;
            if (res.code == 200) {
              this.isAddModal = false;
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 下载二维码
    addRecord(e) {
      console.log(e);
      this.dialogVisible = true;
      this.dialogImageUrl = e;
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad() {
      if (this.timeList.length > 0) {
        this.searchForm.startTime = this.timeList[0];
        this.searchForm.endTime = this.timeList[1];
      }
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ...this.searchForm,
      };
      this.$Apis.patrolClassList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.ind = ind + 1;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>
  
  <style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>